import { ITEM_TYPES } from '@wix/advanced-seo-utils';
import { Box } from '@wix/design-system';
import React from 'react';
import { usePanelStateAtom } from '../../../../../../hooks/rules-state';
import { useA11yWizardAdapter } from '../../../../../../hooks/use-a11y-wizard-adapter';
import { AltImageRuleFixer } from '../../../alt-image-rule-fixer';
import { useAltTextScreenContext } from '../alt-text-screen-wrapper';
export const AltTextScreenContent = () => {
  const {
    getPagesData
  } = usePanelStateAtom();
  const pagesData = getPagesData();
  const {
    a11yWizardAdapter
  } = useA11yWizardAdapter();
  const {
    state: {
      pageId,
      isLoading,
      isPagination,
      pageNumber,
      pages,
      containerRef,
      itemType
    },
    actions: {
      altHandlers,
      getPaginationComponent,
      staticAltHandlers
    }
  } = useAltTextScreenContext();
  const {
    appDefinitionId,
    enabledDecorativeImages,
    openImageElement
  } = altHandlers;
  const openStaticOrVerticalImageElement = element => {
    // if entityId exists in pagesData, the image is from a static page (DM)
    if (pagesData.get(element.entityId ?? '') !== undefined) {
      staticAltHandlers == null || staticAltHandlers.openImageElement(element);
    } else {
      openImageElement(element);
    }
  };
  const elementPadding = isPagination ? `0 SP4 SP2 SP4` : `SP2 SP4`;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    flex: "1 1 auto",
    gap: "SP2",
    minHeight: "0",
    overflowY: "auto",
    padding: elementPadding,
    ref: containerRef
  }, /*#__PURE__*/React.createElement(AltImageRuleFixer, {
    a11yWizardAdapter: a11yWizardAdapter,
    altImagesRules: pages[pageNumber],
    appDefinitionId: appDefinitionId,
    disabled: isLoading,
    enableDecorativeImages: enabledDecorativeImages,
    openImageElement: openStaticOrVerticalImageElement,
    pageId: pageId,
    showSummary: itemType === ITEM_TYPES.STATIC_PAGE_V2
  }), getPaginationComponent({
    isTopPagination: false
  })));
};
//# sourceMappingURL=alt-text-screen-content.js.map